<template>
	<span
		class="Chip" tabindex="0"
		@mousedown.native="handleRemove"
	>
		<span class="ChipLabel">{{ label }}</span>
		<span v-if="count" class="ChipCount">{{ count }}</span>
		<span v-if="icon" class="ChipIcon">
			<i :class="['ChipClose', icon]" aria-hidden="true"></i>
		</span>
		<button v-else class="ChipRemove" type="button" aria-label="Remove tag">
			<i class="ChipClose lnr-cross" aria-hidden="true"></i>
		</button>
	</span>
</template>

<script setup lang="ts">
const props = defineProps({
	label: {
		type: String,
		required: true,
	},
	count: {
		type: Number,
		required: false
	},
	icon: {
		type: String,
		required: false
	}
});

const { label, count, icon } = props;
const emit = defineEmits(['remove']);

const handleRemove = (event: MouseEvent) => {
	if (props.icon) return;

	emit('remove', event);
};
</script>

<style scoped lang="scss">
.Chip {
	display: flex;
	box-sizing: border-box;
	align-items: center;
	border: 1px solid $Blue-700;
	max-width: 100%;
	gap: 0.25rem;
	border-radius: 2rem;
	background: $Blue-100;
	color: $Blue-700;
	position: relative;
	cursor: pointer;

	@include PaddingAreas(0.5);
	@include AddBorderBeforeElement(2, 1);

	&:hover {
		color: $Grey-900;
		border: 1px solid $Blue-600;

		&::before {
			opacity: 1;
		}

		.ChipClose {
			color: $Grey-900;
		}
	}

	.ChipLabel {
		display: block;
		flex: 1 1 auto;
		min-width: 0;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		user-select: none;

		@include TextStyle(UiSmallSemibold);
	}

	.ChipCount {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		background: $Blue-700;
		width: 0.5rem;
		color: $White;
		border-radius: 50%;
		height: 1rem;

		@include TextStyle(UiSmallSemibold);
		@include PaddingAreas(0, 0.25);
	}

	.ChipRemove {
		background: none;
		border: none;
		padding: 0;
		cursor: pointer;
		display: flex;
		align-items: center;
		flex-shrink: 0;
	}

	.ChipClose {
		display: block;
		color: $Blue-700;
	}
}
</style>
